<template>
<div class='bodyer protect body-article'>
    <div class='banner'>
        <img src='/static/image/protect/banner.png'>
    </div>
    <div class='article'>
        <div class='container'>
            <div class='title'>网络游戏未成年人家长监护工程</div>
            <div class='content'>
                <p>“网络游戏未成年人家长监护工程”是一项由各大网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。它提供了一种切实可行的方法，一种家长实施监控的管道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。</p>
                <p class='title'>《未成年人健康参与网络游戏提示》</p>
                <p>随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：</p>
                <p>一、主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。</p>
                <p>二、不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。</p>
                <p>三、不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。</p>
                <p>四、养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。</p>
                <p>五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。</p>
                <p class='title'>家长监护服务说明：</p>
                <p>家长监护系统充分考虑家长的实际需求，当家长发现自己的孩子玩游戏过于沉迷的时候，由家长提供合法的监护人资质证明、游戏名称账号、以及家长对于限制强度的愿望等信息，可对处于孩子游戏沉迷状态的账号采取几种限制措施，解决未成年人沉迷游戏的不良现象，如限制未成年人每天玩游戏的时间区间和长度，也可以限制只有节假日才可以游戏，或者完全禁止。</p>
                <p class='title'>家长监护服务进度查询：</p>
                <p>如果您已经申请家长监护服务，在服务期间，当您对需要提交的信息、处理结果有疑问，或者其他任何问题，您均可以在工作时间联系我们，我们将由专门负责的受理专员为您提供咨询解答服务，或者配合、指导您解决问题。</p>
                <br><br>
                <p class='title'>申请表下载</p>
                <p>表单内容：(附件下载)</p>
                <p>附件表一：<a href='/static/data/01.doc'>监护人信息表明书</a></p>
                <p>附件表二：<a href='/static/data/02.doc'>被监护人信息表明书</a></p>
                <p>附件表三：<a href='/static/data/03.doc'>家长监护申请书</a></p>
                <br><br>
                <p class='title'>咨询方式</p>
                <p>咨询热线：<span class='notice'>023-86062306</span></p>
                <p>受理时间：<span class='notice'>周一至周五9:30-18:00</span></p>
                <p>服务邮箱：<span class='notice'>service@unnda.com或490118757@qq.com</span></p>
                <br><br>
                <p class='title'>防沉迷家长监控系统FAQ</p>
                <p><b>Q：可以通过什么渠道申请家长监督未成年人账号？</b></p>
                <p>A：目前您可以通过电话反馈，传真方式进行申请。</p>
                <p><b>Q：申请监督的账号有什么要求？</b></p>
                <p>A：账号所属人必须未满18周岁，且为大陆公民，不含港、澳、台人士。</p>
                <p><b>Q：申请监督未成年人账号需要提供什么</b></p>
                <p>A：您需要提供监护人身份证复印件、账号所属人身份证复印件以及户口本复印件、公安机关监护证明。</p>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
export default {
    created : function(){
        window.scrollTo(0, 0)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/about/Protect.vue